import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(4)})`,
    clear: 'both',

    [theme.breakpoints.down('md')]: {
      padding: 0,
    },

    pageBreakInside: 'avoid !important',
  },
}));

export default useStyles;
